// extracted by mini-css-extract-plugin
module.exports = {"illustration":"styles_illustration__1Tw7f","header":"styles_header__1dFPR","description":"styles_description__38LHI"};